import _ from 'lodash';
import moment from 'moment';
import DepsService from 'services/dependencies';

import DefaultDialogController from 'utils/notifications/default-dialog-controller';

const defaultDocument = {
  formData: {
    pageType: null,
    jurisdictionId: null,
    tags: [],
  },
};

@Inject('$mdSelect', 'Responsive')
class UploadFormModalController extends DefaultDialogController {
  constructor() {
    super();
    this.document = this.initializeDocument(_.cloneDeep(defaultDocument));
  }

  sortCategories() {
    return (category) => _.get(category, `translations[${this.locale}].name`);
  }

  initializeDocument(document) {
    document.formData.pageType = this.documentType;
    document.formData.jurisdictionId = this.jurisdictionId;
    document.formData.publishingStartDate = moment.unix(this.serverTime);
    return document;
  }

  addTag(tag) {
    if (!tag) {
      return;
    }

    if (!tag || tag.length > this.keywordMaxLength) {
      return this.uploadForm.keywords.$setValidity('keyword-max-length', false);
    }

    this.document.formData.tags = this.document.formData.tags.concat(tag);
    this.tagName = null;
  }

  removeTag(index) {
    this.document.formData.tags.splice(index, 1);
  }

  validateDates(document) {
    this.dateError1 = false;
    const dateFrom = moment(document.formData.publishingStartDate);
    const dateTo = moment(document.formData.publishingEndDate);
    const today = moment.unix(DepsService.config.serverTime);
    if (document.formData.publishingEndDate) {
      this.dateError1 = !dateFrom.isBefore(dateTo, 'day');
    }
    this.dateError2 = dateFrom.isBefore(today, 'day');
  }

  upload(uploadForm) {
    this.document = this.handleCategory(_.cloneDeep(this.document.formData));
    uploadForm.$setSubmitted();
    this.validateDates(this.document);

    const document = _.cloneDeep(this.document);
    document.formData.publishingStartDate = moment(document.formData.publishingStartDate).format('YYYY-MM-DD');
    document.formData.publishingEndDate = document.formData.publishingEndDate ? moment(document.formData.publishingEndDate).format('YYYY-MM-DD') : null;

    if (uploadForm.$valid && !this.dateError1 && !this.dateError2 && !this.fileErrors) {
      this.confirm({
        document: _.cloneDeep(document),
      });
      uploadForm.$setPristine();
      uploadForm.$setUntouched();
    }
  }

  handleCategory(formData) {
    if (_.findIndex(this.categories, { documentTypeId: formData.categoryId * 1 }) === -1) {
      this.document.formData = this.removeCategoryFromList(formData, formData.categoryId);
    }
    return this.document;
  }

  removeCategoryFromList(formData, categoryId) {
    return _.omit(formData, (value) => value === categoryId);
  }
}

export default UploadFormModalController;



// WEBPACK FOOTER //
// ./src/modules/documents/components/documents-management/upload-form-modal/upload-form-modal-controller.js